<template>
  <a-layout class="layout">
    <a-layout-sider
      :collapsible="true"
      v-model:collapsed="collapsed"
      breakpoint="md"
      :collapsed-width="0"
      :width="220"
      :style="{ paddingTop: '60px' }"
    >
      <a-menu
        :selected-keys="selectedKeys"
        :style="{ width: '100%' }"
        @menu-item-click="handleMenuClick"
      >
        <a-menu-item key="/dashboard">
          <template #icon><icon-dashboard /></template>
          仪表盘
        </a-menu-item>
        <a-menu-item key="/orders">
          <template #icon><icon-list /></template>
          订单管理
        </a-menu-item>
        <a-menu-item key="/products">
          <template #icon><icon-gift /></template>
          商品管理
        </a-menu-item>
        <a-menu-item key="/channels">
          <template #icon><icon-safe /></template>
          渠道管理
        </a-menu-item>
        <a-sub-menu key="payment">
          <template #icon><icon-money /></template>
          <template #title>支付管理</template>
          <a-menu-item key="/payment/create">创建支付</a-menu-item>
          <a-menu-item key="/payment/query">支付查询</a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="layout-header">
        <div class="header-left">
          <span class="mobile-menu-btn" @click="collapsed = !collapsed">
            <icon-menu />
          </span>
          <span class="header-title">InPay 支付管理系统</span>
        </div>
        <div class="header-right">
          <span class="header-username">
            <icon-user />
            {{ userStore.username || '用户' }}
          </span>
          <a-button type="outline" size="small" @click="handleLogout">
            退出登录
          </a-button>
        </div>
      </a-layout-header>
      <a-layout-content class="layout-content">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/store/user'
import { Modal } from '@arco-design/web-vue'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const collapsed = ref(false)

const selectedKeys = computed(() => {
  const path = route.path
  // 订单详情页高亮 /orders 菜单
  if (path.startsWith('/orders/')) {
    return ['/orders']
  }
  return [path]
})

function handleMenuClick(key: string) {
  router.push(key)
}

function handleLogout() {
  Modal.confirm({
    title: '确认退出',
    content: '确定要退出登录吗？',
    onOk: () => {
      userStore.logout()
      router.push('/login')
    },
  })
}
</script>

<style scoped>
.layout {
  min-height: 100vh;
}

.layout-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #e5e6eb;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
}

.mobile-menu-btn {
  display: none;
  align-items: center;
  cursor: pointer;
  margin-right: 12px;
  font-size: 20px;
  color: #4e5969;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-username {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #4e5969;
  font-size: 14px;
}

.layout-content {
  padding: 20px;
  background: #f2f3f5;
  min-height: calc(100vh - 60px);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .layout-header {
    padding: 0 12px;
  }
  .mobile-menu-btn {
    display: flex;
  }
  .header-title {
    display: none;
  }
  .layout-content {
    padding: 12px;
  }
}
</style>
